import React, { useState, useEffect } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import breadcrumbImage from "../../../assets/images/course/cousre.jpg";
import axios from "axios";
import DOMPurify from "dompurify";
import { Link, useNavigate } from "react-router-dom";
const MockTestSeries = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedTest, setSelectedTest] = useState(null);
  const [paperList, setPaperList] = useState([]);
  const [bgImage, setBgImage] = useState("");
  const navigate = useNavigate();
  const user_id = localStorage.getItem("user_id");
  const token = localStorage.getItem("token");
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [selectedCourseId, setSelectedCourseId] = useState(null);

  useEffect(() => {
    modelPaperList();
    bannerimg();
  }, []);

  // API call to fetch test list
  const modelPaperList = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/mock-test-paper-list`,
        {
          user_id: user_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status === "1") {
        setPaperList(res.data.data || []);
      } else {
        setPaperList([]);
      }
    } catch (error) {
      console.error("Error fetching paper list:", error);
      setPaperList([]);
    }
  };

  // const modelPaperList = async () => {
  //   try {
  //     // Step 1: Fetch user's purchased plans
  //     const planRes = await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/plan-package-list`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //         body: JSON.stringify({ id: user_id }),
  //       }
  //     );

  //     if (!planRes.ok) throw new Error("Failed to fetch plan");

  //     const planData = await planRes.json();
  //     const allCourseIds = planData.data.map((item) => item.course_id);
  //     const uniqueCourseIds = [...new Set(allCourseIds.map(Number))]; // unique + numeric IDs

  //     // Step 2: Fetch all mock test papers
  //     const res = await axios.post(
  //       `${process.env.REACT_APP_BASE_URL}/mock-test-paper-list`,
  //       { user_id },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     if (res.data.status === "1" && res.data.data) {
  //       // Step 3: Filter mock tests based on user's purchased course_ids
  //       const filteredPapers = res.data.data.filter((paper) =>
  //         uniqueCourseIds.includes(Number(paper.course_id))
  //       );

  //       setPaperList(filteredPapers || []);
  //     } else {
  //       setPaperList([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching paper list:", error);
  //     setPaperList([]);
  //   }
  // };

  const bannerimg = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
      );

      const baseUrl = res.data.imagePath;
      const courseImage = res.data.home_setting[0]?.course_image;

      // Full image URL
      const fullUrl = baseUrl + courseImage;

      setBgImage(fullUrl);
    } catch (error) {
      console.error("Error fetching banner:", error);
    }
  };
  // Instructions formatting
  const renderInstructions = (desc) => {
    if (!desc) return null;
    return desc.split("\n").map((line, idx) => <li key={idx}>{line}</li>);
  };

 const handleAction = async (test) => {
  try {
    const planRes = await fetch(
      `${process.env.REACT_APP_BASE_URL}/plan-package-list`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: user_id }),
      }
    );

    if (!planRes.ok) throw new Error("Failed to fetch plan");
    const planData = await planRes.json();

    // ✅ Filter active plans only
    const activePlans = planData.data.filter(
      (item) => item.status && item.status.toLowerCase() !== "expired"
    );

    // Get all active course IDs
    const activeCourseIds = activePlans.map((item) => Number(item.course_id));

    if (activeCourseIds.includes(Number(test.course_id))) {
      // ✅ User has active plan for this course
      localStorage.setItem("test_id", test.id);

      if (test.test_status === "Completed") {
        navigate("/test-result");
      } else {
        navigate("/mock-test-instructions");
      }
    } else {
      // ❌ User doesn’t have active plan OR plan expired → show purchase modal
      setSelectedCourseId(test.course_id);
      setShowPurchaseModal(true);
    }
  } catch (error) {
    console.error("Error checking plan:", error);
    setShowPurchaseModal(true);
  }
};


  const handleStartTest = (test) => {
    localStorage.setItem("test_id", test.id);
    navigate("/demo-exam");
  };

  return (
    <section className="course Test">
      <div className="page_header"></div>
      <div className="rs-breadcrumbs breadcrumbs-overlay">
        <div className="breadcrumbs-img">
          <img src={bgImage} alt="Breadcrumbs bg" />
        </div>
        <div className="breadcrumbs-text white-color">
          <h1 className="page-title">Test Series</h1>
        </div>
      </div>

      <Container className="py-4">
        <Row>
          {paperList.length > 0 ? (
            paperList.map((test) => (
              <Col key={test.id} md={12} lg={12} className="mb-4">
                <div className="p-3 border rounded shadow-sm h-100 d-flex justify-content-between demo-test-card shadow flex-wrap">
                  <div>
                    <div className="d-flex gap-2 align-items-center mb-3">
                      <h5 className="text-capitalize ">{test.title}</h5>
                      {/* <span className="badge bg-warning text-dark">
                      Test Series
                    </span> */}
                    </div>
                    <div className="d-flex">
                      <p className="mb-1 ">{test.package_name}</p>
                      <p className="mb-1 moke-question ">
                        {test.total_questions}
                      </p>
                      <p className="mb-1 moke-question">
                        {test.duration_minutes} mins
                      </p>
                      <p
                        className={`mb-2 moke-question text-${
                          test.status === "active" ? "success" : "warning"
                        }`}
                      >
                        <strong> {test.status}</strong>
                      </p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center align-items-center">
                    <button
                      type="button"
                      className={`educate-btn w-100 ${
                        test.test_status === "Completed"
                          ? "btn-success"
                          : test.status === "active"
                          ? "btn-primary"
                          : "btn-secondary"
                      }`}
                      disabled={
                        test.status !== "active" &&
                        test.test_status !== "Completed"
                      }
                      onClick={() => handleAction(test)}
                    >
                      {test.test_status === "Completed"
                        ? "Report"
                        : test.status === "active"
                        ? "Live Mock Test"
                        : "Upcoming"}
                      <span className="educate-btn__curve"></span>
                    </button>
                  </div>
                </div>
              </Col>
            ))
          ) : (
            <Col>
              <div className="text-center p-5 border rounded shadow-sm">
                <Container className="py-5 text-center">
                  <div className="page_header"></div>
                  <h3>Please purchase a plan for Live Mock Test</h3>
                  <Link
                    to="/course-detail"
                    onClick={() => localStorage.setItem("courseId", 61)}
                    className="mt-3 educate-btn"
                  >
                    <span className="educate-btn__curve" />
                    Purchase Plan
                  </Link>
                </Container>
              </div>
            </Col>
          )}
        </Row>
      </Container>
      <Modal
        show={showPurchaseModal}
        onHide={() => setShowPurchaseModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Purchase Required</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <h5>Please purchase a plan to access this Mock Test.</h5>
          <Link
            to="/course-detail"
            onClick={() => {
              if (selectedCourseId) {
                localStorage.setItem("courseId", selectedCourseId);
              }
              setShowPurchaseModal(false);
            }}
            className="mt-3 educate-btn"
          >
            <span className="educate-btn__curve" />
            Purchase Plan
          </Link>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default MockTestSeries;
